import React, { useEffect, useMemo, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Slider from "@material-ui/core/Slider";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Menu from "@material-ui/core/Menu";
import CircularProgress from "@material-ui/core/CircularProgress";
import NotificationsActiveOutlinedIcon from "@material-ui/icons/NotificationsActiveOutlined";
import PlayArrowRoundedIcon from "@material-ui/icons/PlayArrowRounded";
import VolumeUpRoundedIcon from "@material-ui/icons/VolumeUpRounded";
import VolumeOffRoundedIcon from "@material-ui/icons/VolumeOffRounded";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RestoreRoundedIcon from "@material-ui/icons/RestoreRounded";
import ChatOutlinedIcon from "@material-ui/icons/ChatOutlined";
import NotificationsNoneOutlinedIcon from "@material-ui/icons/NotificationsNoneOutlined";
import SwapHorizRoundedIcon from "@material-ui/icons/SwapHorizRounded";
import SendOutlinedIcon from "@material-ui/icons/SendOutlined";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import LibraryMusicOutlinedIcon from "@material-ui/icons/LibraryMusicOutlined";
import PersonAddOutlinedIcon from "@material-ui/icons/PersonAddOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import PanToolOutlinedIcon from "@material-ui/icons/PanToolOutlined";
import AnnouncementOutlinedIcon from "@material-ui/icons/AnnouncementOutlined";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import SignalWifiOffIcon from "@material-ui/icons/SignalWifiOff";
import WifiIcon from "@material-ui/icons/Wifi";
import openSocket from "../../services/socket-io";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import {
  SONS,
  EVENTOS,
  GRUPOS_SONS,
  configPadraoSons,
  carregarConfigSons,
  aplicarConfigSons,
  tocarPrevia,
  listarSonsPersonalizados,
} from "../../utils/soundAlerts";

const ICONES = {
  novoCliente: { Icone: PersonAddOutlinedIcon, cor: "linear-gradient(135deg, #0f766e, #2dd4bf)" },
  mensagem: { Icone: ChatOutlinedIcon, cor: "linear-gradient(135deg, #16a34a, #4ade80)" },
  monitor: { Icone: VisibilityOutlinedIcon, cor: "linear-gradient(135deg, #475569, #94a3b8)" },
  transferencia: { Icone: SwapHorizRoundedIcon, cor: "linear-gradient(135deg, #c2410c, #fb923c)" },
  precisaHumano: { Icone: PanToolOutlinedIcon, cor: "linear-gradient(135deg, #b91c1c, #f87171)" },
  avisoIA: { Icone: NotificationsNoneOutlinedIcon, cor: "linear-gradient(135deg, #0369a1, #38bdf8)" },
  comunicado: { Icone: AnnouncementOutlinedIcon, cor: "linear-gradient(135deg, #7c3aed, #c4b5fd)" },
  venda: { Icone: MonetizationOnOutlinedIcon, cor: "linear-gradient(135deg, #a16207, #facc15)" },
  problema: { Icone: ReportProblemOutlinedIcon, cor: "linear-gradient(135deg, #9f1239, #fb7185)" },
  envio: { Icone: SendOutlinedIcon, cor: "linear-gradient(135deg, #6d28d9, #a78bfa)" },
  conexaoCaiu: { Icone: SignalWifiOffIcon, cor: "linear-gradient(135deg, #b91c1c, #f87171)" },
  conexaoVoltou: { Icone: WifiIcon, cor: "linear-gradient(135deg, #15803d, #4ade80)" },
};

const useStyles = makeStyles((theme) => {
  const escuro = theme.palette.type === "dark";
  const borda = escuro ? "rgba(148,163,184,.14)" : "#e3ece6";
  return {
    grade: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
      gap: 12,
    },
    tituloGrupo: {
      margin: "20px 2px 10px",
      fontSize: "0.72rem",
      fontWeight: 800,
      letterSpacing: ".08em",
      textTransform: "uppercase",
      color: theme.palette.text.secondary,
    },
    quem: {
      marginLeft: "auto",
      alignSelf: "flex-start",
      flexShrink: 0,
      fontSize: "0.64rem",
      fontWeight: 800,
      padding: "2px 8px",
      borderRadius: 10,
      whiteSpace: "nowrap",
    },
    linha: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      padding: 14,
      borderRadius: 16,
      border: `1px solid ${borda}`,
      backgroundColor: escuro ? "rgba(255,255,255,.025)" : "#f8fbf9",
    },
    topo: { display: "flex", alignItems: "center", gap: 12 },
    iconeEvento: {
      width: 36, height: 36, borderRadius: 11, flexShrink: 0, color: "#fff",
      display: "flex", alignItems: "center", justifyContent: "center",
      "& .MuiSvgIcon-root": { fontSize: 19 },
    },
    nome: { fontWeight: 800, fontSize: "0.88rem", color: theme.palette.text.primary },
    detalhe: { fontSize: "0.72rem", color: theme.palette.text.secondary, lineHeight: 1.4 },
    escolha: { display: "flex", alignItems: "center", gap: 8 },
    seletor: {
      flex: 1, minWidth: 0, display: "flex", alignItems: "center", justifyContent: "space-between",
      gap: 8, padding: "8px 10px 8px 14px", borderRadius: 12, cursor: "pointer",
      border: `1px solid ${borda}`, backgroundColor: theme.palette.background.paper,
      fontWeight: 700, fontSize: "0.84rem", color: theme.palette.text.primary,
      "&:hover": { borderColor: "#22c55e" },
    },
    tocar: {
      backgroundColor: escuro ? "rgba(34,197,94,.15)" : "#e7f7ee",
      color: "#16a34a",
      "&:hover": { backgroundColor: escuro ? "rgba(34,197,94,.25)" : "#d3f0df" },
    },
    volume: { display: "flex", alignItems: "center", gap: 10, padding: "0 4px" },
    slider: { color: "#22c55e" },
    volumeTexto: { fontSize: "0.72rem", fontWeight: 800, width: 34, textAlign: "right", color: theme.palette.text.secondary },
    menuPapel: { borderRadius: 14, marginTop: 6, width: 320, maxHeight: 420 },
    opcao: {
      display: "flex", alignItems: "center", gap: 8, padding: "7px 8px 7px 12px",
      margin: "2px 6px", borderRadius: 10, cursor: "pointer",
      "&:hover": { backgroundColor: theme.palette.action.hover },
    },
    opcaoAtiva: { backgroundColor: escuro ? "rgba(34,197,94,.12)" : "#eaf8f0" },
    aviso: { fontSize: "0.74rem", color: theme.palette.text.secondary, marginTop: 12 },
    acoes: { display: "flex", alignItems: "center", gap: 10, marginTop: 14, flexWrap: "wrap" },
    grupoMenu: {
      padding: "10px 18px 4px",
      fontSize: "0.66rem",
      fontWeight: 800,
      letterSpacing: ".08em",
      textTransform: "uppercase",
      color: theme.palette.text.secondary,
    },
    enviar: {
      display: "flex", alignItems: "center", gap: 8, margin: "6px 6px 6px", padding: "10px 12px",
      borderRadius: 10, cursor: "pointer", fontWeight: 800, fontSize: "0.82rem", color: "#16a34a",
      border: `1px dashed ${escuro ? "rgba(74,222,128,.35)" : "#9fd9b5"}`,
      "&:hover": { backgroundColor: escuro ? "rgba(34,197,94,.08)" : "#f0faf4" },
    },
    excluir: { color: theme.palette.text.secondary, "&:hover": { color: "#ef4444" } },
  };
});

const SonsNotificacao = ({ classesPagina = {} }) => {
  const classes = useStyles();
  const [cfg, setCfg] = useState(configPadraoSons());
  const [salvo, setSalvo] = useState(JSON.stringify(configPadraoSons()));
  const [salvando, setSalvando] = useState(false);
  const [menu, setMenu] = useState({ anchor: null, evento: null });
  const [proprios, setProprios] = useState([]);
  const [enviando, setEnviando] = useState(false);
  const inputArquivo = useRef(null);

  const atualizarProprios = async () => setProprios(await listarSonsPersonalizados());

  useEffect(() => {
    atualizarProprios();
    const socket = openSocket();
    const aoMudar = () => atualizarProprios();
    socket.on("sonsPersonalizados", aoMudar);
    return () => socket.off("sonsPersonalizados", aoMudar);
  }, []);

  const enviarArquivo = async (arquivo) => {
    if (!arquivo) return;
    if (arquivo.size > 3 * 1024 * 1024) {
      toast.error("O áudio passa de 3 MB. Use um arquivo menor ou mais curto.");
      return;
    }
    const evento = menu.evento;
    setEnviando(true);
    try {
      const form = new FormData();
      form.append("arquivo", arquivo);
      const { data } = await api.post("/sons-personalizados", form);
      await atualizarProprios();
      if (data?.id && evento) {
        alterar(evento, "som", data.id);
        tocarPrevia(data.id, cfg[evento]?.volume || 70);
        toast.success(`"${data.nome}" escolhido. Clique em Salvar sons para aplicar.`);
      } else {
        toast.success("Áudio enviado.");
      }
      setMenu({ anchor: null, evento: null });
    } catch (err) {
      toastError(err);
    } finally {
      setEnviando(false);
      if (inputArquivo.current) inputArquivo.current.value = "";
    }
  };

  const excluirArquivo = async (som) => {
    if (!window.confirm(`Excluir o áudio "${som.nome}"? Quem usa ele volta para o som padrão.`)) return;
    try {
      await api.delete(`/sons-personalizados/${encodeURIComponent(som.arquivo)}`);
      // quem usava este audio volta para o padrao e ja salva
      const novo = { ...cfg };
      let mudou = false;
      EVENTOS.forEach((e) => {
        if (novo[e.id]?.som === som.id) {
          novo[e.id] = { ...novo[e.id], som: e.padrao };
          mudou = true;
        }
      });
      if (mudou) {
        setCfg(novo);
        await api.put("/settings/sonsNotificacao", { value: JSON.stringify(novo) });
        aplicarConfigSons(novo);
        setSalvo(JSON.stringify(novo));
      }
      await atualizarProprios();
      toast.success("Áudio excluído.");
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    (async () => {
      const atual = await carregarConfigSons();
      setCfg(atual);
      setSalvo(JSON.stringify(atual));
    })();
  }, []);

  const pendente = useMemo(() => JSON.stringify(cfg) !== salvo, [cfg, salvo]);

  const alterar = (evento, campo, valor) =>
    setCfg((c) => ({ ...c, [evento]: { ...c[evento], [campo]: valor } }));

  const salvar = async () => {
    setSalvando(true);
    try {
      await api.put("/settings/sonsNotificacao", { value: JSON.stringify(cfg) });
      aplicarConfigSons(cfg);
      setSalvo(JSON.stringify(cfg));
      toast.success("Sons salvos para toda a equipe.");
    } catch (err) {
      toastError(err);
    } finally {
      setSalvando(false);
    }
  };

  const nomeDoSom = (id) =>
    (SONS.find((s) => s.id === id) || proprios.find((s) => s.id === id) || {}).nome ||
    (String(id).startsWith("arquivo:") ? "Áudio próprio" : id);
  const eventoMenu = menu.evento;

  return (
    <div className={classesPagina.bloco} style={{ animationDelay: ".12s" }}>
      <div className={classesPagina.topoBloco}>
        <div className={classesPagina.icone} style={{ background: "linear-gradient(135deg, #b45309, #fbbf24)" }}>
          <NotificationsActiveOutlinedIcon />
        </div>
        <Box flex={1} minWidth={200}>
          <Typography className={classesPagina.tituloCartao} style={{ fontSize: "1.05rem" }}>
            Sons e notificações
          </Typography>
          <span className={classesPagina.descricaoCartao}>
            Cada situação tem o seu som. Clique no nome para trocar, no ▶ para ouvir e ajuste o volume.
            Vale para toda a equipe.
          </span>
        </Box>
      </div>

      {GRUPOS_SONS.map((grupo) => (
      <React.Fragment key={grupo.id}>
      <div className={classes.tituloGrupo}>{grupo.nome}</div>
      <div className={classes.grade}>
        {EVENTOS.filter((ev) => ev.grupo === grupo.id).map((ev) => {
          const atual = cfg[ev.id] || { som: ev.padrao, volume: ev.volume };
          const { Icone, cor } = ICONES[ev.id] || ICONES.avisoIA;
          const mudo = atual.som === "nenhum" || !atual.volume;
          return (
            <div key={ev.id} className={classes.linha}>
              <div className={classes.topo}>
                <div className={classes.iconeEvento} style={{ background: cor }}>
                  <Icone />
                </div>
                <div style={{ minWidth: 0 }}>
                  <div className={classes.nome}>{ev.nome}</div>
                  <div className={classes.detalhe}>{ev.detalhe}</div>
                </div>
                <Tooltip title={ev.quem === "Admin" ? "Só administradores ouvem este som" : "Todos os usuários ouvem este som"} arrow>
                  <span
                    className={classes.quem}
                    style={ev.quem === "Admin"
                      ? { color: "#b45309", backgroundColor: "rgba(245,158,11,.14)" }
                      : { color: "#15803d", backgroundColor: "rgba(34,197,94,.14)" }}
                  >
                    {ev.quem === "Admin" ? "Só admin" : "Todos"}
                  </span>
                </Tooltip>
              </div>

              <div className={classes.escolha}>
                <div
                  className={classes.seletor}
                  onClick={(e) => setMenu({ anchor: e.currentTarget, evento: ev.id })}
                >
                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {nomeDoSom(atual.som)}
                  </span>
                  <ExpandMoreRoundedIcon fontSize="small" style={{ opacity: 0.6 }} />
                </div>
                <Tooltip title="Ouvir" arrow>
                  <span>
                    <IconButton
                      size="small"
                      className={classes.tocar}
                      disabled={mudo}
                      onClick={() => tocarPrevia(atual.som, atual.volume)}
                    >
                      <PlayArrowRoundedIcon />
                    </IconButton>
                  </span>
                </Tooltip>
              </div>

              <div className={classes.volume}>
                {mudo ? (
                  <VolumeOffRoundedIcon fontSize="small" style={{ opacity: 0.5 }} />
                ) : (
                  <VolumeUpRoundedIcon fontSize="small" style={{ opacity: 0.7 }} />
                )}
                <Slider
                  className={classes.slider}
                  value={atual.volume}
                  min={0}
                  max={100}
                  step={5}
                  onChange={(e, v) => alterar(ev.id, "volume", v)}
                  onChangeCommitted={(e, v) => tocarPrevia(atual.som, v)}
                />
                <span className={classes.volumeTexto}>{atual.volume}%</span>
              </div>
            </div>
          );
        })}
      </div>
      </React.Fragment>
      ))}

      <div className={classes.aviso}>
        O navegador só libera som depois do primeiro clique na página. Se o atendente não ouvir nada,
        peça para clicar uma vez em qualquer lugar do sistema.
      </div>

      <div className={classes.acoes}>
        <Button
          variant="contained"
          color="primary"
          className={classesPagina.botaoPrimario}
          startIcon={salvando ? <CircularProgress size={14} color="inherit" /> : <CheckCircleOutlineIcon />}
          onClick={salvar}
          disabled={!pendente || salvando}
        >
          Salvar sons
        </Button>
        <Button
          className={classesPagina.botaoSecundario}
          startIcon={<RestoreRoundedIcon />}
          onClick={() => setCfg(configPadraoSons())}
        >
          Restaurar padrão
        </Button>
        {!pendente && (
          <span className={classes.detalhe} style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
            <CheckRoundedIcon style={{ fontSize: 16, color: "#22c55e" }} /> Tudo salvo
          </span>
        )}
      </div>

      <input
        ref={inputArquivo}
        type="file"
        accept="audio/*,.mp3,.wav,.ogg,.m4a,.aac,.opus,.webm"
        style={{ display: "none" }}
        onChange={(e) => enviarArquivo(e.target.files && e.target.files[0])}
      />

      {/* Lista de sons prontos: clique no ▶ para ouvir, no nome para escolher */}
      <Menu
        anchorEl={menu.anchor}
        open={!!menu.anchor}
        onClose={() => setMenu({ anchor: null, evento: null })}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ className: classes.menuPapel }}
      >
        {eventoMenu && (
          <div className={classes.grupoMenu} style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <LibraryMusicOutlinedIcon style={{ fontSize: 14 }} /> Seus áudios
          </div>
        )}
        {eventoMenu &&
          proprios.map((som) => {
            const ativo = cfg[eventoMenu]?.som === som.id;
            return (
              <div
                key={som.id}
                className={`${classes.opcao} ${ativo ? classes.opcaoAtiva : ""}`}
                onClick={() => {
                  alterar(eventoMenu, "som", som.id);
                  tocarPrevia(som.id, cfg[eventoMenu]?.volume || 70);
                  setMenu({ anchor: null, evento: null });
                }}
              >
                <IconButton
                  size="small"
                  className={classes.tocar}
                  onClick={(e) => {
                    e.stopPropagation();
                    tocarPrevia(som.id, cfg[eventoMenu]?.volume || 70);
                  }}
                >
                  <PlayArrowRoundedIcon fontSize="small" />
                </IconButton>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className={classes.nome} style={{ fontSize: "0.84rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {som.nome}
                  </div>
                  <div className={classes.detalhe}>Áudio enviado</div>
                </div>
                {ativo && <CheckRoundedIcon style={{ color: "#22c55e", fontSize: 18 }} />}
                <Tooltip title="Excluir áudio" arrow>
                  <IconButton
                    size="small"
                    className={classes.excluir}
                    onClick={(e) => {
                      e.stopPropagation();
                      excluirArquivo(som);
                    }}
                  >
                    <DeleteOutlineRoundedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
            );
          })}
        {eventoMenu && (
          <div className={classes.enviar} onClick={() => !enviando && inputArquivo.current?.click()}>
            {enviando ? <CircularProgress size={16} /> : <CloudUploadOutlinedIcon fontSize="small" />}
            <div>
              {enviando ? "Enviando..." : "Enviar áudio do computador"}
              <div className={classes.detalhe} style={{ fontWeight: 400 }}>MP3, WAV, OGG ou M4A — até 3 MB (toca no máximo 10s)</div>
            </div>
          </div>
        )}
        {eventoMenu && <div className={classes.grupoMenu}>Sons prontos</div>}
        {eventoMenu &&
          SONS.map((som) => {
            const ativo = cfg[eventoMenu]?.som === som.id;
            return (
              <div
                key={som.id}
                className={`${classes.opcao} ${ativo ? classes.opcaoAtiva : ""}`}
                onClick={() => {
                  alterar(eventoMenu, "som", som.id);
                  tocarPrevia(som.id, cfg[eventoMenu]?.volume || 70);
                  setMenu({ anchor: null, evento: null });
                }}
              >
                <IconButton
                  size="small"
                  className={classes.tocar}
                  disabled={som.id === "nenhum"}
                  onClick={(e) => {
                    e.stopPropagation();
                    tocarPrevia(som.id, cfg[eventoMenu]?.volume || 70);
                  }}
                >
                  <PlayArrowRoundedIcon fontSize="small" />
                </IconButton>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className={classes.nome} style={{ fontSize: "0.84rem" }}>{som.nome}</div>
                  <div className={classes.detalhe}>{som.detalhe}</div>
                </div>
                {ativo && <CheckRoundedIcon style={{ color: "#22c55e", fontSize: 18 }} />}
              </div>
            );
          })}
      </Menu>
    </div>
  );
};

export default SonsNotificacao;
